import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 
const firebaseConfig = {
  apiKey: "AIzaSyAXOg5EX7yg-KS7-sOTxPqqclhXpEtifOQ",
  authDomain: "bigma-28b1c.firebaseapp.com",
  projectId: "bigma-28b1c",
  storageBucket: "bigma-28b1c.firebasestorage.app",
  messagingSenderId: "636052448258",
  appId: "1:636052448258:web:9dd3d1dd47877732b6731b",
  measurementId: "G-CCCGXJ8W63"
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); 